import { render, staticRenderFns } from "./RelatorioManutencao.vue?vue&type=template&id=4aad3fb3&scoped=true"
import script from "./RelatorioManutencao.vue?vue&type=script&lang=js"
export * from "./RelatorioManutencao.vue?vue&type=script&lang=js"
import style0 from "./RelatorioManutencao.vue?vue&type=style&index=0&id=4aad3fb3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aad3fb3",
  null
  
)

export default component.exports